/**
 * ADHIK BY RADHIKA — Indian Summer Theme
 * Header scroll, mobile menu, drag-scroll
 */
(function () {
  'use strict';

  /* ═══════════════════════════════════
     UTILITY — THROTTLE
     ═══════════════════════════════════ */
  function adhikThrottle(fn, ms) {
    var last = 0;
    return function() {
      var now = Date.now();
      if (now - last >= ms) { last = now; fn.apply(this, arguments); }
    };
  }

  /* ═══════════════════════════════════
     BUY NOW — FETCH + VALIDATE + REDIRECT
     ═══════════════════════════════════ */
  window.adhikBuyNow = function(btn) {
    var variantInput = document.querySelector('#adhik-product-form input[name="id"]');
    var variantId = variantInput ? variantInput.value : null;
    if (!variantId) {
      alert('Please select all options before buying.');
      return;
    }
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Processing...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function(r) {
      return r.json().then(function(data) { return { ok: r.ok, status: r.status, data: data }; });
    })
    .then(function(res) {
      if (!res.ok) {
        /* Shopify returns { status, message, description } on failure */
        var errMsg = (res.data && (res.data.description || res.data.message)) || 'Item could not be added.';
        throw new Error(errMsg);
      }
      if (!res.data || !res.data.id) {
        throw new Error('Item was not added to cart.');
      }
      /* Verify cart by fetching it before redirect */
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r) { return r.json(); });
    })
    .then(function(cart) {
      if (!cart || cart.item_count < 1) {
        throw new Error('Cart is empty after add.');
      }
      window.location.href = '/checkout';
    })
    .catch(function(err) {
      btn.disabled = false;
      btn.textContent = originalText;
      alert((err && err.message) || 'Something went wrong. Please try again.');
    });
  };

  /* ═══════════════════════════════════
     HEADER — SCROLL STATE
     ═══════════════════════════════════ */
  var header = document.querySelector('.adhik-header');

  if (header) {
    var scrollThreshold = 60;

    function updateHeaderScroll() {
      var y = window.scrollY || window.pageYOffset;
      if (y > scrollThreshold) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }

    window.addEventListener('scroll', adhikThrottle(updateHeaderScroll, 50), { passive: true });
    updateHeaderScroll();
  }


  /* ═══════════════════════════════════
     MOBILE MENU
     ═══════════════════════════════════ */
  var mobileMenu = document.getElementById('adhikMobileMenu');
  var menuToggles = document.querySelectorAll('[data-mobile-menu-toggle]');
  var menuCloses  = document.querySelectorAll('[data-mobile-menu-close]');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  for (var t = 0; t < menuToggles.length; t++) {
    menuToggles[t].addEventListener('click', openMobileMenu);
  }
  for (var c = 0; c < menuCloses.length; c++) {
    menuCloses[c].addEventListener('click', closeMobileMenu);
  }

  /* Close on link click */
  if (mobileMenu) {
    var mobileLinks = mobileMenu.querySelectorAll('.adhik-mobile-menu__link');
    for (var l = 0; l < mobileLinks.length; l++) {
      mobileLinks[l].addEventListener('click', closeMobileMenu);
    }
  }

  /* Close on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-open')) {
      closeMobileMenu();
    }
  });


  /* ═══════════════════════════════════
     DRAG-TO-SCROLL (Essentials)
     ═══════════════════════════════════ */
  var dragScrolls = document.querySelectorAll('[data-drag-scroll]');

  for (var d = 0; d < dragScrolls.length; d++) {
    (function (el) {
      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;

      el.addEventListener('mousedown', function (e) {
        isDown = true;
        el.classList.add('is-dragging');
        startX = e.pageX - el.offsetLeft;
        scrollLeft = el.scrollLeft;
      });

      el.addEventListener('mouseleave', function () {
        isDown = false;
        el.classList.remove('is-dragging');
      });

      el.addEventListener('mouseup', function () {
        isDown = false;
        el.classList.remove('is-dragging');
      });

      el.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - el.offsetLeft;
        var walk = (x - startX) * 1.5;
        el.scrollLeft = scrollLeft - walk;
      });
    })(dragScrolls[d]);
  }

  /* ═══════════════════════════════════
     SOCIAL PROOF — CAROUSEL DOTS
     ═══════════════════════════════════ */
  var spStage = document.querySelector('.adhik-sp__stage');
  var spDots = document.querySelectorAll('.adhik-sp__dot');
  if (spStage && spDots.length) {
    spStage.addEventListener('scroll', function() {
      var index = Math.round(spStage.scrollLeft / (spStage.scrollWidth / 3));
      for (var i = 0; i < spDots.length; i++) {
        if (i === index) {
          spDots[i].classList.add('adhik-sp__dot--active');
        } else {
          spDots[i].classList.remove('adhik-sp__dot--active');
        }
      }
    }, { passive: true });
  }

  /* ═══════════════════════════════════
     PDP — IMAGE PREV/NEXT ARROWS
     ═══════════════════════════════════ */
  var adhikCurrentImageIndex = 0;
  var adhikTotalImages = document.querySelectorAll('.adhik-pdp__slide').length;

  window.adhikGoToImage = function(index) {
    document.querySelectorAll('.adhik-pdp__slide').forEach(function(s, i) {
      s.classList.toggle('is-active', i === index);
    });
    adhikCurrentImageIndex = index;
  };

  window.adhikPrevImage = function() {
    var total = document.querySelectorAll('.adhik-pdp__slide').length;
    if (!total) return;
    var newIndex = (adhikCurrentImageIndex - 1 + total) % total;
    adhikGoToImage(newIndex);
    document.querySelectorAll('.adhik-pdp__thumb').forEach(function(t, i) {
      t.classList.toggle('is-active', i === newIndex);
    });
  };

  window.adhikNextImage = function() {
    var total = document.querySelectorAll('.adhik-pdp__slide').length;
    if (!total) return;
    var newIndex = (adhikCurrentImageIndex + 1) % total;
    adhikGoToImage(newIndex);
    document.querySelectorAll('.adhik-pdp__thumb').forEach(function(t, i) {
      t.classList.toggle('is-active', i === newIndex);
    });
  };

  /* PDP — swipe gestures on mobile */
  var pdpSlides = document.getElementById('adhik-slides');
  if (pdpSlides) {
    var touchStartX = 0;
    var touchStartY = 0;
    var touchMoved = false;
    var SWIPE_THRESHOLD = 40;

    pdpSlides.addEventListener('touchstart', function(e) {
      if (!e.touches || !e.touches.length) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchMoved = false;
    }, { passive: true });

    pdpSlides.addEventListener('touchmove', function(e) {
      if (!e.touches || !e.touches.length) return;
      var dx = e.touches[0].clientX - touchStartX;
      var dy = e.touches[0].clientY - touchStartY;
      if (Math.abs(dx) > 10 || Math.abs(dy) > 10) touchMoved = true;
    }, { passive: true });

    pdpSlides.addEventListener('touchend', function(e) {
      if (!touchMoved) return;
      var endX = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : touchStartX;
      var endY = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientY : touchStartY;
      var dx = endX - touchStartX;
      var dy = endY - touchStartY;
      // Horizontal swipe wins only if mostly horizontal
      if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) { window.adhikNextImage(); } else { window.adhikPrevImage(); }
      }
    });
  }

  /* ═══════════════════════════════════
     FLOATING WHATSAPP — PUSH UP ON PDP
     ═══════════════════════════════════ */
  var waFloat = document.querySelector('.adhik-wa-float');
  if (waFloat) {
    if (document.body.classList.contains('template-product') || document.querySelector('.adhik-pdp')) {
      if (window.innerWidth <= 768) {
        waFloat.style.bottom = '88px';
      }
    }
    window.addEventListener('resize', function() {
      if (document.querySelector('.adhik-pdp')) {
        waFloat.style.bottom = window.innerWidth <= 768 ? '88px' : '28px';
      }
    });
  }

  /* ═══════════════════════════════════
     PDP — IMAGE ZOOM LIGHTBOX
     ═══════════════════════════════════ */
  window.adhikOpenZoom = function(src) {
    var activeSlide = document.querySelector('.adhik-pdp__slide.is-active img');
    var zoomSrc = activeSlide ? activeSlide.src.replace('width=900', 'width=1400') : src;
    var zoom = document.getElementById('adhik-zoom');
    var zoomImg = document.getElementById('adhik-zoom-img');
    if (zoom && zoomImg) {
      zoomImg.src = zoomSrc;
      zoom.classList.add('is-open');
    }
  };

  /* ═══════════════════════════════════
     BUNDLE PROGRESS BAR
     ═══════════════════════════════════ */
  var bundleBar = document.getElementById('adhik-bundle-bar');
  var bundleFill = document.getElementById('adhik-bundle-fill');
  var bundleMsg = document.getElementById('adhik-bundle-msg');

  if (bundleBar && bundleFill && bundleMsg) {
    var DISCOUNT_15 = 'ADHIK15';
    var DISCOUNT_20 = 'ADHIK20';
    var lastAppliedCode = null;

    function applyDiscount(code) {
      if (lastAppliedCode === code) return;
      lastAppliedCode = code;
      fetch('/discount/' + code, { method: 'GET', credentials: 'same-origin' })
        .then(function() {
          showDiscountToast(code);
        });
    }

    function removeDiscount() {
      if (!lastAppliedCode) return;
      lastAppliedCode = null;
      fetch('/discount/REMOVE', { method: 'GET', credentials: 'same-origin' });
    }

    function showDiscountToast(code) {
      var toast = document.getElementById('adhik-discount-toast');
      var title = document.getElementById('adhik-toast-title');
      var sub = document.getElementById('adhik-toast-sub');
      if (!toast || !title || !sub) return;

      var percent = code === 'ADHIK20' ? '20%' : '15%';
      var saving = code === 'ADHIK20' ? 'Buy 3 items' : 'Buy 2 items';
      title.textContent = percent + ' off applied to your order!';
      sub.textContent = saving + ' \u00B7 Discount shows at checkout';

      toast.classList.add('is-visible');
      clearTimeout(window.adhikToastTimer);
      window.adhikToastTimer = setTimeout(function() {
        toast.classList.remove('is-visible');
      }, 6000);
    }

    window.showDiscountToast = showDiscountToast;

    /* Manual close for toast */
    var toastEl = document.getElementById('adhik-discount-toast');
    if (toastEl && !toastEl.querySelector('.adhik-discount-toast__close')) {
      var closeX = document.createElement('button');
      closeX.type = 'button';
      closeX.className = 'adhik-discount-toast__close';
      closeX.setAttribute('aria-label', 'Dismiss');
      closeX.innerHTML = '&times;';
      closeX.addEventListener('click', function() {
        toastEl.classList.remove('is-visible');
        clearTimeout(window.adhikToastTimer);
      });
      toastEl.appendChild(closeX);
    }

    function isBundleDismissed(itemCount) {
      try {
        var stored = sessionStorage.getItem('adhikBundleDismissed');
        if (!stored) return false;
        /* If cart count changed since dismissal, re-show */
        return parseInt(stored, 10) === itemCount;
      } catch (e) { return false; }
    }

    function dismissBundle(itemCount) {
      try { sessionStorage.setItem('adhikBundleDismissed', String(itemCount)); } catch (e) {}
      bundleBar.classList.remove('is-visible');
    }

    var closeBtn = document.getElementById('adhik-bundle-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        var currentCount = (bundleBar.getAttribute('data-item-count') || '0');
        dismissBundle(parseInt(currentCount, 10));
      });
    }

    function updateBundleBar(itemCount) {
      var dots = bundleBar.querySelectorAll('.adhik-bundle__bar-dot');
      var tiers = bundleBar.querySelectorAll('.adhik-bundle__tier');
      var msgLink = document.getElementById('adhik-bundle-msg-link');

      bundleBar.setAttribute('data-item-count', itemCount);

      if (itemCount === 0) {
        bundleBar.classList.remove('is-visible');
        return;
      }

      /* Respect session dismissal unless cart count changed */
      if (isBundleDismissed(itemCount)) {
        bundleBar.classList.remove('is-visible');
        /* Still apply discount logic below so cart code stays synced */
      } else {
        bundleBar.classList.add('is-visible');
      }
      if (msgLink) msgLink.classList.remove('is-unlocked');

      if (itemCount === 1) {
        bundleFill.style.width = '25%';
        dots[0].classList.add('is-reached');
        dots[1].classList.remove('is-reached');
        dots[2].classList.remove('is-reached');
        tiers[0].classList.add('is-active');
        tiers[1].classList.remove('is-active', 'is-reached');
        tiers[2].classList.remove('is-active', 'is-reached');
        bundleMsg.innerHTML = 'Add <strong>1 more item</strong> to save <strong>15%</strong> on your order';
        removeDiscount();
      } else if (itemCount === 2) {
        bundleFill.style.width = '60%';
        dots[0].classList.add('is-reached');
        dots[1].classList.add('is-reached');
        dots[2].classList.remove('is-reached');
        tiers[0].classList.add('is-reached');
        tiers[1].classList.add('is-active', 'is-reached');
        tiers[2].classList.remove('is-active', 'is-reached');
        bundleMsg.innerHTML = 'Add <strong>1 more item</strong> to save <strong>20%</strong> on your order';
        applyDiscount(DISCOUNT_15);
      } else {
        bundleFill.style.width = '100%';
        dots[0].classList.add('is-reached');
        dots[1].classList.add('is-reached');
        dots[2].classList.add('is-reached');
        tiers[0].classList.add('is-reached');
        tiers[1].classList.add('is-reached');
        tiers[2].classList.add('is-active', 'is-reached');
        bundleMsg.innerHTML = '<span class="adhik-bundle__celebrate">\uD83C\uDF89 20% off unlocked</span> &middot; Continue shopping';
        if (msgLink) msgLink.classList.add('is-unlocked');
        applyDiscount(DISCOUNT_20);
      }
    }

    function fetchCartAndUpdate() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          updateBundleBar(cart.item_count);
        })
        .catch(function() {
          bundleBar.classList.remove('is-visible');
        });
    }

    fetchCartAndUpdate();

    document.addEventListener('cart:updated', function(e) {
      if (e.detail && e.detail.cart) {
        updateBundleBar(e.detail.cart.item_count);
      } else {
        fetchCartAndUpdate();
      }
    });

    document.addEventListener('click', function(e) {
      if (e.target.matches('[data-type="add-to-cart-form"] [type="submit"]') ||
          e.target.closest('.adhik-pdp__atc') ||
          e.target.closest('.adhik-plp__quick-add')) {
        setTimeout(fetchCartAndUpdate, 800);
      }
    });

    var adhikBundleTimer = null;
    var adhikLastActivity = Date.now();
    document.addEventListener('click', function() { adhikLastActivity = Date.now(); });
    document.addEventListener('scroll', function() { adhikLastActivity = Date.now(); }, { passive: true });

    function adhikStartBundlePolling() {
      if (adhikBundleTimer) return;
      adhikBundleTimer = setInterval(function() {
        if (Date.now() - adhikLastActivity > 300000) {
          clearInterval(adhikBundleTimer);
          adhikBundleTimer = null;
          return;
        }
        fetchCartAndUpdate();
      }, 10000);
    }
    adhikStartBundlePolling();
  }

  /* ═══════════════════════════════════
     BUNDLE LOOK — SCROLL ARROWS + DRAG
     ═══════════════════════════════════ */
  var blGrid = document.getElementById('bl-grid');
  var blPrev = document.getElementById('bl-prev');
  var blNext = document.getElementById('bl-next');

  if (blGrid && blPrev && blNext) {
    var cardWidth = 192;

    function updateArrows() {
      blPrev.classList.toggle('is-hidden', blGrid.scrollLeft <= 0);
      blNext.classList.toggle('is-hidden', blGrid.scrollLeft >= blGrid.scrollWidth - blGrid.clientWidth - 4);
    }

    blPrev.addEventListener('click', function() {
      blGrid.scrollBy({ left: -(cardWidth * 2), behavior: 'smooth' });
    });
    blNext.addEventListener('click', function() {
      blGrid.scrollBy({ left: cardWidth * 2, behavior: 'smooth' });
    });
    blGrid.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();

    var isDragging = false;
    var startX = 0;
    var scrollStart = 0;
    blGrid.addEventListener('mousedown', function(e) {
      isDragging = true;
      startX = e.pageX - blGrid.offsetLeft;
      scrollStart = blGrid.scrollLeft;
      blGrid.style.cursor = 'grabbing';
      blGrid.style.userSelect = 'none';
    });
    blGrid.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      var x = e.pageX - blGrid.offsetLeft;
      blGrid.scrollLeft = scrollStart - (x - startX);
    });
    blGrid.addEventListener('mouseup', function() {
      isDragging = false;
      blGrid.style.cursor = '';
      blGrid.style.userSelect = '';
    });
    blGrid.addEventListener('mouseleave', function() {
      isDragging = false;
      blGrid.style.cursor = '';
      blGrid.style.userSelect = '';
    });
  }

  /* ═══════════════════════════════════
     PLP — QUICK ADD (size picker)
     ═══════════════════════════════════ */
  function adhikQuickAddFetch(variantId, button) {
    if (!variantId) return;
    button.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    })
    .then(function() {
      button.classList.remove('is-loading');
      var card = button.closest('.adhik-plp__card');
      if (card) {
        var atcBtn = card.querySelector('.adhik-plp__quick-add');
        var picker = card.querySelector('.adhik-plp__size-picker');
        if (picker) picker.classList.remove('is-open');
        if (atcBtn) {
          atcBtn.classList.add('is-added');
          atcBtn.setAttribute('aria-expanded', 'false');
          setTimeout(function() { atcBtn.classList.remove('is-added'); }, 1800);
        }
      }
      document.dispatchEvent(new CustomEvent('cart:updated'));
      /* Open cart drawer after successful add */
      if (typeof window.adhikOpenCartDrawer === 'function') {
        setTimeout(window.adhikOpenCartDrawer, 120);
      }
    })
    .catch(function() {
      button.classList.remove('is-loading');
      var card = button.closest('.adhik-plp__card');
      var atcBtn = card ? card.querySelector('.adhik-plp__quick-add') : null;
      if (atcBtn) {
        atcBtn.textContent = 'Try again';
        setTimeout(function() { atcBtn.textContent = 'Add to Cart'; }, 1800);
      }
    });
  }

  document.addEventListener('click', function(e) {
    /* Toggle size picker */
    var toggle = e.target.closest('[data-quick-add-toggle]');
    if (toggle) {
      e.preventDefault();
      var card = toggle.closest('.adhik-plp__card');
      var picker = card ? card.querySelector('[data-size-picker]') : null;
      if (!picker) return;
      /* Close any other open pickers */
      document.querySelectorAll('.adhik-plp__size-picker.is-open').forEach(function(p) {
        if (p !== picker) p.classList.remove('is-open');
      });
      var isOpen = picker.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }

    /* Size pill click → add to cart */
    var pill = e.target.closest('.adhik-plp__size-pill');
    if (pill && !pill.disabled && !pill.classList.contains('is-sold-out')) {
      e.preventDefault();
      adhikQuickAddFetch(pill.getAttribute('data-variant-id'), pill);
      return;
    }

    /* Single-variant direct add */
    var directAdd = e.target.closest('[data-quick-add]');
    if (directAdd) {
      e.preventDefault();
      adhikQuickAddFetch(directAdd.getAttribute('data-variant-id'), directAdd);
      return;
    }

    /* Click outside any open picker → close */
    if (!e.target.closest('.adhik-plp__size-picker') && !e.target.closest('[data-quick-add-toggle]')) {
      document.querySelectorAll('.adhik-plp__size-picker.is-open').forEach(function(p) {
        p.classList.remove('is-open');
        var btn = p.parentElement ? p.parentElement.querySelector('[data-quick-add-toggle]') : null;
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }
  });

  /* ═══════════════════════════════════
     PDP FORM — INTERCEPT + OPEN DRAWER
     ═══════════════════════════════════ */
  var pdpForm = document.getElementById('adhik-product-form');
  if (pdpForm) {
    pdpForm.addEventListener('submit', function(e) {
      /* Only intercept the Add-to-Cart submit; Buy Now uses onclick separately */
      var submitter = e.submitter || pdpForm.querySelector('[type="submit"]');
      if (!submitter) return;
      /* Skip if something native-checkout-named triggered it */
      if (submitter.name === 'checkout') return;
      e.preventDefault();
      var originalText = submitter.textContent;
      submitter.disabled = true;
      submitter.textContent = 'Adding...';
      var formData = new FormData(pdpForm);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
      .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, data: d }; }); })
      .then(function(res) {
        submitter.disabled = false;
        if (!res.ok) {
          submitter.textContent = originalText;
          var msg = (res.data && (res.data.description || res.data.message)) || 'Could not add to cart.';
          alert(msg);
          return;
        }
        submitter.textContent = '\u2713 Added';
        setTimeout(function() { submitter.textContent = originalText; }, 1800);
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (typeof window.adhikOpenCartDrawer === 'function') {
          setTimeout(window.adhikOpenCartDrawer, 120);
        }
      })
      .catch(function() {
        /* Network error: fall back to native form post so user isn't stuck */
        submitter.disabled = false;
        submitter.textContent = originalText;
        pdpForm.submit();
      });
    });
  }

  /* ═══════════════════════════════════
     CART DRAWER
     ═══════════════════════════════════ */
  var drawer = document.getElementById('adhik-cart-drawer');
  var drawerLastFocused = null;
  var drawerCart = null;

  function drawerEl(sel) { return drawer ? drawer.querySelector(sel) : null; }

  function openDrawer() {
    if (!drawer) return;
    drawerLastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    /* Focus the close button for a11y */
    var closeBtn = drawerEl('[data-drawer-close].adhik-drawer__close');
    if (closeBtn) setTimeout(function() { closeBtn.focus(); }, 120);
    /* Refresh cart */
    drawerFetchAndRender();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (drawerLastFocused && typeof drawerLastFocused.focus === 'function') {
      try { drawerLastFocused.focus(); } catch(e) {}
    }
  }

  window.adhikOpenCartDrawer = openDrawer;
  window.adhikCloseCartDrawer = closeDrawer;

  /* Drawer open/close event delegation */
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-cart-drawer-trigger]');
    if (trigger && drawer) {
      e.preventDefault();
      openDrawer();
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer && drawer && drawer.classList.contains('is-open')) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    var closeOnclick = e.target.closest('[data-drawer-close-onclick]');
    if (closeOnclick && drawer && drawer.classList.contains('is-open')) {
      /* Don't prevent default — let the link navigate */
      closeDrawer();
    }
  });

  /* Escape closes drawer */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  /* ─── Drawer: render helpers ─────────────────────── */
  function drawerBundleMessage(itemCount) {
    if (itemCount >= 3) return '<span class="adhik-drawer__celebrate">\uD83C\uDF89 20% off unlocked!</span>';
    if (itemCount === 2) return 'Add <strong>1 more item</strong> to save <strong>20%</strong>';
    if (itemCount === 1) return 'Add <strong>1 more item</strong> to save <strong>15%</strong>';
    return '';
  }

  function drawerBundleFill(itemCount) {
    /* Fill lines up with 3-dot positions at 0%, 50%, 100% */
    if (itemCount >= 3) return 100;
    if (itemCount === 2) return 50;
    if (itemCount === 1) return 0; /* dot 1 lit, bar not yet progressing toward tier 2 */
    return 0;
  }

  function renderDrawerItems(cart) {
    var itemsEl = drawerEl('[data-drawer-items]');
    var tpl = document.getElementById('adhik-drawer-item-template');
    if (!itemsEl || !tpl) return;
    itemsEl.innerHTML = '';
    (cart.items || []).forEach(function(item, idx) {
      var frag = tpl.content.cloneNode(true);
      var row = frag.querySelector('[data-drawer-line]');
      var lineNum = idx + 1;
      row.setAttribute('data-drawer-line', lineNum);

      var imgLink = frag.querySelector('[data-drawer-item-url]');
      if (imgLink) imgLink.href = item.url;

      var img = frag.querySelector('[data-drawer-item-img]');
      if (img && item.image) {
        var src = item.image.indexOf('http') === 0 ? item.image : 'https:' + item.image;
        img.src = src;
        img.alt = item.product_title || item.title || '';
      }

      var title = frag.querySelector('[data-drawer-item-title]');
      if (title) {
        title.textContent = item.product_title || item.title;
        title.href = item.url;
      }

      var variant = frag.querySelector('[data-drawer-item-variant]');
      if (variant) {
        var vTitle = item.variant_title || '';
        /* Don't show "Default Title" */
        if (vTitle && vTitle !== 'Default Title') variant.textContent = vTitle;
      }

      var soldOut = frag.querySelector('[data-drawer-item-soldout]');
      if (soldOut && item.variant_id) {
        /* Check availability — cart.js returns item.variant_id but not availability directly.
           item has `product_has_only_default_variant`; Shopify includes in `cart.items_subtotal_price` etc.
           Availability check is best-effort: check `inventory_quantity` if present. */
        var unavailable = item.quantity > (item.inventory_quantity || Infinity) && item.inventory_policy !== 'continue';
        soldOut.hidden = !unavailable;
      }

      var qtyInput = frag.querySelector('[data-drawer-qty-input]');
      if (qtyInput) {
        qtyInput.value = item.quantity;
        qtyInput.setAttribute('data-line', lineNum);
        qtyInput.setAttribute('data-prev-qty', item.quantity);
      }
      var qtyDown = frag.querySelector('[data-drawer-qty-down]');
      var qtyUp   = frag.querySelector('[data-drawer-qty-up]');
      if (qtyDown) qtyDown.setAttribute('data-line', lineNum);
      if (qtyUp)   qtyUp.setAttribute('data-line', lineNum);
      if (qtyDown && item.quantity <= 1) qtyDown.setAttribute('data-to-zero', 'true');

      var removeBtn = frag.querySelector('[data-drawer-item-remove]');
      if (removeBtn) removeBtn.setAttribute('data-line', lineNum);

      var priceEl = frag.querySelector('[data-drawer-item-price]');
      if (priceEl) priceEl.textContent = adhikFormatMoney(item.final_line_price);

      itemsEl.appendChild(frag);
    });
  }

  function renderDrawer(cart) {
    if (!drawer || !cart) return;
    drawerCart = cart;

    /* Count in header */
    var countEl = drawerEl('[data-drawer-count]');
    if (countEl) countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';

    /* Header cart badge */
    var headerBadge = document.querySelector('[data-header-cart-badge]');
    if (headerBadge) {
      headerBadge.textContent = cart.item_count;
      headerBadge.hidden = cart.item_count === 0;
    }

    /* Empty vs populated */
    var emptyEl  = drawerEl('[data-drawer-empty]');
    var itemsEl  = drawerEl('[data-drawer-items]');
    var footerEl = drawerEl('[data-drawer-footer]');
    var bundleEl = drawerEl('[data-drawer-bundle]');

    if (cart.item_count === 0) {
      if (emptyEl)  emptyEl.hidden = false;
      if (itemsEl)  itemsEl.hidden = true;
      if (footerEl) footerEl.hidden = true;
      if (bundleEl) bundleEl.hidden = true;
      return;
    }

    if (emptyEl)  emptyEl.hidden = true;
    if (itemsEl)  itemsEl.hidden = false;
    if (footerEl) footerEl.hidden = false;

    /* Line items */
    renderDrawerItems(cart);

    /* Totals */
    var hasDiscount = cart.original_total_price > cart.total_price;
    var discountAmt = cart.original_total_price - cart.total_price;

    var subtotalEl  = drawerEl('[data-drawer-subtotal]');
    var totalEl     = drawerEl('[data-drawer-total]');
    var discRow     = drawerEl('[data-drawer-discount-row]');
    var discAmt     = drawerEl('[data-drawer-discount-amount]');
    var discLabel   = drawerEl('[data-drawer-discount-label]');
    var savedRow    = drawerEl('[data-drawer-saved-row]');
    var savedEl     = drawerEl('[data-drawer-saved]');

    if (subtotalEl) {
      subtotalEl.textContent = adhikFormatMoney(cart.original_total_price);
      if (hasDiscount) {
        subtotalEl.style.textDecoration = 'line-through';
        subtotalEl.style.color = 'var(--coconut-60)';
      } else {
        subtotalEl.style.textDecoration = '';
        subtotalEl.style.color = '';
      }
    }
    if (totalEl) totalEl.textContent = adhikFormatMoney(cart.total_price);

    if (discRow) {
      discRow.hidden = !hasDiscount;
      if (hasDiscount && discAmt) discAmt.innerHTML = '&minus; ' + adhikFormatMoney(discountAmt);
      if (hasDiscount && discLabel && cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
        discLabel.textContent = cart.cart_level_discount_applications[0].title || 'Bundle discount';
      } else if (hasDiscount && discLabel) {
        discLabel.textContent = 'Bundle discount';
      }
    }
    if (savedRow) savedRow.hidden = !hasDiscount;
    if (savedEl && hasDiscount) savedEl.textContent = adhikFormatMoney(discountAmt);

    /* Bundle progress inside drawer */
    if (bundleEl) {
      bundleEl.hidden = false;
      var msgEl = drawerEl('[data-drawer-bundle-msg]');
      var fillEl = drawerEl('[data-drawer-bundle-fill]');
      if (msgEl) msgEl.innerHTML = drawerBundleMessage(cart.item_count);
      if (fillEl) fillEl.style.width = drawerBundleFill(cart.item_count) + '%';

      /* Mark tier labels reached */
      var tierEls = bundleEl.querySelectorAll('.adhik-drawer__bundle-tier');
      tierEls.forEach(function(t) {
        var tierNum = parseInt(t.getAttribute('data-tier'), 10);
        if (!isNaN(tierNum) && cart.item_count >= tierNum) {
          t.classList.add('is-reached');
        } else {
          t.classList.remove('is-reached');
        }
      });

      /* Mark dots reached */
      var dotEls = bundleEl.querySelectorAll('[data-drawer-dot]');
      dotEls.forEach(function(d) {
        var dotNum = parseInt(d.getAttribute('data-drawer-dot'), 10);
        if (!isNaN(dotNum) && cart.item_count >= dotNum) {
          d.classList.add('is-reached');
        } else {
          d.classList.remove('is-reached');
        }
      });
    }

    /* Upsell strip (Complete the look) */
    renderDrawerUpsell(cart);
  }

  function drawerFetchAndRender() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderDrawer(cart); return cart; })
      .catch(function() {});
  }

  /* ─── Drawer: Upsell recommendations (Shopify native API) ─── */
  /* Parse server-rendered excluded product IDs (couple-wear, family-wear) once */
  var drawerExcludedIds = [];
  (function() {
    var el = document.getElementById('adhik-drawer-excluded-products');
    if (!el) return;
    try {
      var parsed = JSON.parse(el.textContent || '{}');
      if (parsed && Array.isArray(parsed.ids)) {
        drawerExcludedIds = parsed.ids.map(function(x) { return parseInt(x, 10); }).filter(function(x) { return !isNaN(x); });
      }
    } catch (e) {}
  })();

  function drawerFetchRecs(seedProductId) {
    var cacheKey = 'adhikUpsellRecs_' + seedProductId;
    try {
      var cachedRaw = sessionStorage.getItem(cacheKey);
      if (cachedRaw) {
        var cached = JSON.parse(cachedRaw);
        /* 5 min TTL */
        if (cached && cached.ts && Date.now() - cached.ts < 300000 && cached.products) {
          return Promise.resolve(cached.products);
        }
      }
    } catch (e) {}
    return fetch('/recommendations/products.json?product_id=' + seedProductId + '&limit=10&intent=related', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = (data && data.products) ? data.products : [];
        try { sessionStorage.setItem(cacheKey, JSON.stringify({ ts: Date.now(), products: products })); } catch (e) {}
        return products;
      })
      .catch(function() { return []; });
  }

  function drawerFormatMoney(cents) { return adhikFormatMoney(cents); }

  function renderDrawerUpsell(cart) {
    var upsellEl = drawerEl('[data-drawer-upsell]');
    var trackEl  = drawerEl('[data-drawer-upsell-track]');
    var subEl    = drawerEl('[data-drawer-upsell-sub]');
    var tpl = document.getElementById('adhik-drawer-upsell-template');
    if (!upsellEl || !trackEl || !tpl) return;

    /* Hide if cart empty */
    if (!cart || !cart.items || !cart.items.length) {
      upsellEl.hidden = true;
      return;
    }

    /* Subheader message mirrors drawer tier state */
    if (subEl) {
      if (cart.item_count >= 3) {
        subEl.textContent = "You've unlocked 20% off — add more you love";
      } else if (cart.item_count === 2) {
        subEl.textContent = 'Add 1 more to unlock 20% off';
      } else {
        subEl.textContent = 'Add 1 more to unlock 15% off';
      }
    }

    var seedId = cart.items[0].product_id;
    /* Exclude: products already in cart + couple-wear + family-wear */
    var excludeIds = cart.items.map(function(it) { return it.product_id; }).concat(drawerExcludedIds);

    drawerFetchRecs(seedId).then(function(products) {
      var filtered = (products || []).filter(function(p) {
        return excludeIds.indexOf(p.id) === -1;
      }).slice(0, 10);

      if (filtered.length === 0) {
        upsellEl.hidden = true;
        return;
      }

      trackEl.innerHTML = '';
      filtered.forEach(function(p) {
        var frag = tpl.content.cloneNode(true);

        var urlEls = frag.querySelectorAll('[data-upsell-url], [data-upsell-title-link]');
        urlEls.forEach(function(el) { el.href = p.url; });

        var titleEl = frag.querySelector('[data-upsell-title-link]');
        if (titleEl) titleEl.textContent = p.title;

        var imgEl = frag.querySelector('[data-upsell-img]');
        if (imgEl && p.featured_image) {
          var src = (typeof p.featured_image === 'string')
            ? p.featured_image
            : (p.featured_image.url || p.featured_image.src || '');
          if (src) {
            if (src.indexOf('http') !== 0) src = 'https:' + src;
            imgEl.src = src;
            imgEl.alt = p.title || '';
          }
        }

        var priceEl = frag.querySelector('[data-upsell-price]');
        var compareEl = frag.querySelector('[data-upsell-compare]');

        /* Bundle-discount aware pricing — matches PDP "Complete the look" behaviour.
           Tier depends on item count AFTER this product is added. */
        var nextCount = cart.item_count + 1;
        var discountRate = 0;
        if (nextCount >= 3) discountRate = 0.20;
        else if (nextCount >= 2) discountRate = 0.15;

        if (priceEl && compareEl) {
          if (discountRate > 0) {
            var bundlePrice = Math.round(p.price * (1 - discountRate));
            priceEl.textContent = drawerFormatMoney(bundlePrice);
            compareEl.textContent = drawerFormatMoney(p.price);
            compareEl.hidden = false;
          } else {
            /* No bundle discount — fall back to regular price w/ optional compare_at */
            priceEl.textContent = drawerFormatMoney(p.price);
            if (p.compare_at_price && p.compare_at_price > p.price) {
              compareEl.textContent = drawerFormatMoney(p.compare_at_price);
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }
        }

        /* Build size pills OR instant-add button */
        var sizesEl = frag.querySelector('[data-upsell-sizes]');
        var addBtn  = frag.querySelector('[data-upsell-add]');
        var variants = p.variants || [];

        /* Does it have a Size option? Detect by option_with_values or by variant title looking like sizes */
        var hasSize = false;
        if (p.options) {
          for (var i = 0; i < p.options.length; i++) {
            var optName = (typeof p.options[i] === 'string') ? p.options[i] : (p.options[i].name || '');
            if (optName.toLowerCase().indexOf('size') !== -1) { hasSize = true; break; }
          }
        }

        if (variants.length > 1 && hasSize) {
          /* Size pills */
          variants.forEach(function(v) {
            /* If multi-option product, use first option as display (usually Size) */
            var label = v.title;
            if (v.title && v.title.indexOf(' / ') !== -1) label = v.title.split(' / ')[0];
            var pill = document.createElement('button');
            pill.type = 'button';
            pill.className = 'adhik-drawer__upsell-size';
            if (!v.available) pill.classList.add('is-sold-out');
            pill.disabled = !v.available;
            pill.setAttribute('data-drawer-upsell-size', '');
            pill.setAttribute('data-variant-id', v.id);
            pill.textContent = label;
            pill.title = label + (v.available ? '' : ' — Sold out');
            sizesEl.appendChild(pill);
          });
          if (addBtn) addBtn.hidden = true;
        } else if (variants.length === 1 && variants[0].available) {
          /* Single variant — instant add */
          if (sizesEl) sizesEl.style.display = 'none';
          if (addBtn) {
            addBtn.hidden = false;
            addBtn.setAttribute('data-variant-id', variants[0].id);
          }
        } else {
          /* No purchasable variant — hide add actions entirely */
          if (sizesEl) sizesEl.style.display = 'none';
          if (addBtn) addBtn.hidden = true;
        }

        trackEl.appendChild(frag);
      });

      upsellEl.hidden = false;
    });
  }

  /* Size pill OR instant-add click → add to cart */
  document.addEventListener('click', function(e) {
    var target = e.target.closest('[data-drawer-upsell-size], [data-upsell-add]');
    if (!target || target.disabled) return;
    e.preventDefault();
    var variantId = parseInt(target.getAttribute('data-variant-id'), 10);
    if (isNaN(variantId)) return;
    target.disabled = true;
    var originalHTML = target.innerHTML;
    target.innerHTML = '<span class="adhik-drawer__upsell-adding">...</span>';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
    .then(function() {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r) { return r.json(); });
    })
    .then(function(cart) {
      renderDrawer(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    })
    .catch(function() {
      target.disabled = false;
      target.innerHTML = originalHTML;
    });
  });

  /* Initial render — keeps header badge fresh, seeds drawerCart */
  if (drawer) drawerFetchAndRender();

  /* Listen to global cart:updated event (dispatched by ATC handlers) */
  document.addEventListener('cart:updated', function(e) {
    if (e.detail && e.detail.cart) {
      renderDrawer(e.detail.cart);
    } else {
      drawerFetchAndRender();
    }
  });

  /* ─── Drawer: qty +/- buttons ───────────────────── */
  document.addEventListener('click', function(e) {
    var up = e.target.closest('[data-drawer-qty-up]');
    var down = e.target.closest('[data-drawer-qty-down]');
    if (!up && !down) return;
    var btn = up || down;
    var line = parseInt(btn.getAttribute('data-line'), 10);
    if (isNaN(line)) return;
    var input = drawer.querySelector('[data-drawer-qty-input][data-line="' + line + '"]');
    if (!input) return;
    var current = parseInt(input.value, 10) || 0;
    var next = up ? current + 1 : current - 1;
    if (next < 0) return;
    if (next > 99) return;
    input.value = next;
    /* Fire change event so the drawer-qty change handler runs */
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ─── Drawer: qty input change ───────────────────── */
  var drawerQtyTimer = null;
  document.addEventListener('change', function(e) {
    var input = e.target.closest('[data-drawer-qty-input]');
    if (!input) return;
    var line = parseInt(input.getAttribute('data-line'), 10);
    var qty  = parseInt(input.value, 10);
    var prev = parseInt(input.getAttribute('data-prev-qty') || '1', 10);
    if (isNaN(line) || isNaN(qty) || qty < 0 || qty > 99) { input.value = prev; return; }
    input.disabled = true;
    clearTimeout(drawerQtyTimer);
    drawerQtyTimer = setTimeout(function() {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
      .then(function(r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
      .then(function(cart) {
        renderDrawer(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function() { input.disabled = false; input.value = prev; });
    }, 300);
  });

  /* ─── Drawer: remove item ───────────────────── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-drawer-item-remove]');
    if (!btn) return;
    e.preventDefault();
    var line = parseInt(btn.getAttribute('data-line'), 10);
    if (isNaN(line)) return;
    btn.disabled = true;
    btn.style.opacity = '0.5';
    var originalText = btn.textContent;
    btn.textContent = 'Removing...';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    })
    .then(function(r) { if (!r.ok) throw new Error('remove failed'); return r.json(); })
    .then(function(cart) {
      renderDrawer(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    })
    .catch(function() {
      btn.disabled = false;
      btn.style.opacity = '';
      btn.textContent = originalText;
    });
  });

  /* ═══════════════════════════════════
     CART — UTILITIES (format money, patch DOM)
     ═══════════════════════════════════ */
  function adhikFormatMoney(cents) {
    /* Simple INR formatter — matches Shopify's default `{{ money }}` output for en-IN */
    var rupees = (cents / 100);
    /* Shopify default renders like "Rs. 1,234.00" for INR shops */
    var formatted = rupees.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'Rs. ' + formatted;
  }

  function adhikPatchCartDOM(cart) {
    /* Update each line's price */
    (cart.items || []).forEach(function(item, i) {
      var lineIdx = i + 1;
      var priceEl = document.querySelector('[data-cart-line-price="' + lineIdx + '"]');
      if (priceEl) priceEl.textContent = adhikFormatMoney(item.final_line_price);
      var qtyInput = document.querySelector('[data-cart-qty][data-line="' + lineIdx + '"]');
      if (qtyInput && parseInt(qtyInput.value, 10) !== item.quantity) {
        qtyInput.value = item.quantity;
        qtyInput.setAttribute('data-prev-qty', item.quantity);
      }
    });

    /* Update totals */
    var subtotalEl  = document.querySelector('[data-cart-subtotal]');
    var totalEl     = document.querySelector('[data-cart-total]');
    var discRow     = document.querySelector('[data-cart-discount-row]');
    var discAmt     = document.querySelector('[data-cart-discount-amount]');
    var discLabel   = document.querySelector('[data-cart-discount-label]');
    var savedRow    = document.querySelector('[data-cart-saved-row]');
    var savedEl     = document.querySelector('[data-cart-saved]');

    var hasDiscount = cart.original_total_price > cart.total_price;
    var discountAmount = cart.original_total_price - cart.total_price;

    if (subtotalEl) {
      subtotalEl.textContent = adhikFormatMoney(cart.original_total_price);
      if (hasDiscount) {
        subtotalEl.style.textDecoration = 'line-through';
        subtotalEl.style.color = 'var(--coconut-60)';
      } else {
        subtotalEl.style.textDecoration = '';
        subtotalEl.style.color = '';
      }
    }
    if (totalEl) totalEl.textContent = adhikFormatMoney(cart.total_price);

    if (discRow) {
      discRow.style.display = hasDiscount ? 'flex' : 'none';
      if (hasDiscount && discAmt) discAmt.innerHTML = '&minus; ' + adhikFormatMoney(discountAmount);
      if (hasDiscount && discLabel && cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
        discLabel.textContent = cart.cart_level_discount_applications[0].title || 'Bundle discount';
      }
    }
    if (savedRow) savedRow.style.display = hasDiscount ? 'block' : 'none';
    if (savedEl && hasDiscount) savedEl.textContent = adhikFormatMoney(discountAmount);
  }

  /* ═══════════════════════════════════
     CART — AUTO-UPDATE QUANTITY (no reload)
     ═══════════════════════════════════ */
  var cartQtyTimer = null;
  document.addEventListener('change', function(e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var line = parseInt(input.getAttribute('data-line'), 10);
    var qty = parseInt(input.value, 10);
    var prev = parseInt(input.getAttribute('data-prev-qty') || '1', 10);

    /* Guard: invalid / negative / not a number — revert and bail */
    if (isNaN(line) || isNaN(qty) || qty < 0 || qty > 99) {
      input.value = prev;
      return;
    }

    input.disabled = true;
    clearTimeout(cartQtyTimer);
    cartQtyTimer = setTimeout(function() {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
      .then(function(r) {
        if (!r.ok) throw new Error('cart change failed');
        return r.json();
      })
      .then(function(cart) {
        input.disabled = false;
        input.setAttribute('data-prev-qty', qty);
        /* If a line was removed (qty=0) OR item_count changed by more than just this change,
           structural DOM changes needed — do a soft reload that preserves scroll */
        if (qty === 0) {
          var scrollY = window.scrollY;
          sessionStorage.setItem('adhikCartScrollY', String(scrollY));
          window.location.reload();
          return;
        }
        adhikPatchCartDOM(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function() {
        input.disabled = false;
        input.value = prev;
      });
    }, 350);
  });

  /* ═══════════════════════════════════
     CART — REMOVE LINE
     ═══════════════════════════════════ */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    var line = parseInt(btn.getAttribute('data-line'), 10);
    if (isNaN(line)) return;
    btn.disabled = true;
    btn.style.opacity = '0.5';
    btn.textContent = 'Removing...';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('remove failed');
      return r.json();
    })
    .then(function() {
      /* Removing a line restructures the DOM; preserve scroll and reload */
      sessionStorage.setItem('adhikCartScrollY', String(window.scrollY));
      window.location.reload();
    })
    .catch(function() {
      btn.disabled = false;
      btn.style.opacity = '';
      btn.textContent = 'Remove';
    });
  });

  /* Restore scroll after cart soft-reload */
  if (document.querySelector('.adhik-cart-page')) {
    var savedScroll = sessionStorage.getItem('adhikCartScrollY');
    if (savedScroll) {
      window.scrollTo(0, parseInt(savedScroll, 10));
      sessionStorage.removeItem('adhikCartScrollY');
    }
  }

  /* ═══════════════════════════════════
     CART — REFRESH ON VISIBILITY CHANGE (#13)
     Handles user editing cart in another tab / coming back after adding elsewhere
     ═══════════════════════════════════ */
  if (document.querySelector('.adhik-cart-page')) {
    var lastFocusCheck = Date.now();
    document.addEventListener('visibilitychange', function() {
      if (document.visibilityState !== 'visible') return;
      /* Only check if tab was hidden > 5s */
      if (Date.now() - lastFocusCheck < 5000) return;
      lastFocusCheck = Date.now();
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var renderedCount = document.querySelectorAll('[data-cart-line-container]').length;
          var renderedQtySum = 0;
          document.querySelectorAll('[data-cart-qty]').forEach(function(i) {
            renderedQtySum += parseInt(i.value, 10) || 0;
          });
          /* Structural change: different line count OR different total qty → reload */
          if (cart.items.length !== renderedCount || cart.item_count !== renderedQtySum) {
            window.location.reload();
          } else {
            /* Totals may still have shifted (e.g. discount tier flipped) */
            adhikPatchCartDOM(cart);
          }
        })
        .catch(function() {});
    });
  }

})();
